import { useEffect, useState, type InputHTMLAttributes } from "react";
import { formatBRL, parseBRL } from "@cx/domain";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "value" | "onChange"> & {
  value: number | null;
  onChange(cents: number | null): void;
};
const show = (c: number | null) => (c === null ? "" : formatBRL(c).replace(/^-?R\$\s/, c < 0 ? "-" : ""));

/** Confirma o valor no blur. O FormPage tira o foco antes do alt+S, então o valor digitado entra no salvamento (FE7). */
export function MoneyInput({ value, onChange, className = "form-control text-end", ...rest }: Props) {
  const [text, setText] = useState(show(value));
  const [invalid, setInvalid] = useState(false);
  useEffect(() => {
    setText(show(value));
  }, [value]);
  const marked = invalid || rest["aria-invalid"] === "true" || rest["aria-invalid"] === true;
  return (
    <div className="input-group">
      <span className="input-group-text">R$</span>
      <input
        {...rest}
        inputMode="decimal"
        className={`${className}${marked ? " is-invalid" : ""}`}
        aria-invalid={marked ? "true" : undefined}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onBlur={() => {
          if (text.trim() === "") {
            setInvalid(false);
            onChange(null);
            return;
          }
          try {
            const cents = parseBRL(text);
            setInvalid(false);
            setText(show(cents));
            onChange(cents);
          } catch {
            setInvalid(true);
          }
        }}
      />
    </div>
  );
}
